import type { ReactNode } from "react";

export default function SectionModules({
  colorPrimary,
  children,
}: {
  colorPrimary: string;
  children: ReactNode;
}) {
  return (
    <article
      className="modules-container"
      style={{
        // @ts-expect-error custom property
        "--section-primary": colorPrimary,
      }}
    >
      <div className="modules container">{children}</div>
      <style jsx>{`
        .modules-container {
          --module-color: #fff;
          background-color: #f7f7f9;
          padding-bottom: 24px;
        }
        .modules {
          display: grid;
          gap: var(--module-gap);
        }
        @media screen and (min-width: 820px) {
          .modules {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }
        @media (min-width: 1250px) {
          .modules-container {
            padding-top: var(--module-gap);
            padding-bottom: calc(3 * var(--module-gap));
          }
          .modules {
            gap: 40px var(--module-gap);
          }
        }
        .modules p :global(a) {
          font-weight: bold;
        }
      `}</style>
    </article>
  );
}
